import React from "react";
import { FaBell, FaPowerOff, FaUserCircle } from "react-icons/fa";
import "./CSS/Topbar.css";
import { useUser } from "./Context/UserContext.tsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { useNavigate } from "react-router-dom";
const Topbar: React.FC = () => {
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  const handleLogout = () => {
    // Clear user data on logout
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("userFirstName");
    localStorage.removeItem("userEmail");
    setUser(null); // Clear context state
    navigate("/login"); // Navigate to the login page after logout
  };
  return (
    <div className="topbar">
      {/* Left Section - Welcome Message */}

      <div className="topbar-left pt-4">
        {user ? (
          <div className="user-info">
            <p className="welcome-message">
              <FaUserCircle className="icon" />
              Welcome, {user.firstName}! 
            </p>
          </div>
        ) : (
          <p>Please log in.</p>
        )}
      </div>

      {/* Right Section - Notification Icon and Logout Button */}
      <div className="topbar-right">
       
        {user && (
          <button className="logout-btn" onClick={handleLogout}>
            <FaPowerOff className="icon" /> Logout
          </button>
        )}
      </div>
    </div>
  );
};

export default Topbar;
